/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 *
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date          Author        Remarks
 * 1.0.0    23 Jun 2021   Tuan Le       Bug 44454 - [Bronner] [SBOX] Retail Site - Pass form data to Evergage
 */

define(
    'BTM.EvergageFormData.EvergageFormData'
    , [
        'underscore',
        'BTM.EvergageFormData.EvergageFormData.View',
        'Profile.Model',
        'jQuery',
        'SC.Configuration',
        'FormView',
        'Header.View'
    ]
    , function (
        _,
        EvergageFormDataView,
        ProfileModel,
        jQuery,
        Configuration,
        FormView,
        HeaderView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                // using the 'Layout' component we add a new child view inside the 'Header' existing view
                // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
                // more documentation of the Extensibility API in
                // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

                /** @type {LayoutComponent} */
                /*var layout = container.getComponent('Layout');

                if(layout)
                {
                    layout.addChildView('Header.Logo', function() {
                        return new EvergageFormDataView({ container: container });
                    });
                }*/

                var beaconURL = Configuration.get("brEvergageFormData.beaconURL");
                if (!Configuration.get('brEvergageFormData.enabled') || beaconURL == '') {
                    return;
                }

                HeaderView.prototype.initialize = _.wrap(HeaderView.prototype.initialize, function (fn, options) {
                    fn.apply(this, _.toArray(arguments).slice(1));
                    try {
                        this.on('afterViewRender', function () {
                            if (window && typeof Evergage == "undefined") {
                                var _aaq = window._aaq || (window._aaq = []);

                                (function () {
                                    var d = document, g = d.createElement('script'),
                                        s = d.getElementsByTagName('script')[0];
                                    g.type = 'text/javascript';
                                    g.async = true;
                                    g.src = document.location.protocol + beaconURL;
                                    s.parentNode.insertBefore(g, s);
                                })();
                                // Detect Internet Explorer
                                var ua = window.navigator.userAgent;
                                // console.log("userAgentString: " + ua);
                                // alert("userAgentString: " + ua);
                                var isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
                                if (!isFirefox) {
                                    var IExplorerAgent = ua.indexOf("msie") > -1 || ua.indexOf("rv:") > -1;
                                    if (IExplorerAgent) {
                                        alert("Sorry! We no longer support Internet Explorer. Please use another Web Browser to continue");
                                        window.history.back();
                                    }
                                }
                            }
                        });
                    } catch (err) {
                    }
                });

                if (!Configuration.get('brEvergageFormData.enabledEmitData')) {
                    return;
                }

                /*if (window) {
                    var profileModel = ProfileModel.getInstance();
                    window.evergageFormData = {email: profileModel.get('email')};
                }

                var cart = container.getComponent('Cart');
                if (cart) {
                    cart.on('beforeSubmit', function () {
                        try {
                            var profileModel = ProfileModel.getInstance();
                            let event = new CustomEvent("evergageFormData", {detail: {email: profileModel.get('email')}});
                            document.dispatchEvent(event);
                        } catch (err) {
                            console.error(err);
                        }
                        return jQuery.Deferred().resolve();
                    });
                }*/

                // For testing
                /*document.addEventListener("evergageFormData", function(event) { // (1)
                    console.log(event.detail);
                });*/

                FormView.FormView.prototype.saveForm = _.wrap(FormView.FormView.prototype.saveForm, function (fn, options) {
                    var result = fn.apply(this, _.toArray(arguments).slice(1));
                    try {
                        if (Evergage && arguments && arguments["1"] && arguments["1"].target) {
                            var savingForm = jQuery(arguments["1"].target);
                            if (savingForm) {
                                var savingFormData = savingForm.closest('form');
                                if (savingFormData) {
                                    var formValue = this.getFormValues(savingFormData);
                                    if (formValue && formValue.email) {
                                        var formSubmission = 'Form Submission';
                                        if (arguments["1"].delegateTarget && arguments["1"].delegateTarget.dataset && arguments["1"].delegateTarget.dataset.view) {
                                            formSubmission = " | " + arguments["1"].delegateTarget.dataset.view;
                                        }
                                        Evergage.sendEvent({
                                            action: formSubmission,
                                            user: {
                                                attributes: {
                                                    emailAddress: formValue.email
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        console.error(err);
                    }
                    return result;
                });
            }
        };
    });
